import * as React from 'react'
import {Dialog, DialogDismiss, DialogHeading} from '@ariakit/react'
import * as dialogStyles from '@frontrow/console/src/components/dialog/dialog.module.scss'
import {Button} from '@frontrow/console/src/components/button'

// Models
import {type DetailedSchoolAdminT} from '@frontrow/console/src/models/school-admin'
// Components
import SchoolAdminSchoolsForm from '@frontrow/console/src/components/pages/school-admins-page/school-admins-schools-button-modal/school-admins-schools-form'
import {useModalForm} from '@frontrow/console/src/hooks/use-modal-form'

type Props = {
  schoolAdminToUpdate: DetailedSchoolAdminT
  updateSchoolAdminSchools: (
    schoolAdminId: number,
    addSchoolIds: Array<number>,
    deleteSchoolIds: Array<number>
  ) => void
}

function SchoolsAdminSchoolsButtonModal(props: Props): React.ReactElement {
  const {schoolAdminToUpdate, updateSchoolAdminSchools} = props
  const {isOpen, open, close} = useModalForm()

  const updateSchoolAdminSchoolsHandler = (
    addSchoolIds: Array<number>,
    deleteSchoolIds: Array<number>
  ) => {
    updateSchoolAdminSchools(schoolAdminToUpdate.id, addSchoolIds, deleteSchoolIds)
    close()
  }

  return (
    <React.Fragment>
      <Button style="link" title="Update School Admin Schools" onClick={open}>
        <i className="fa fa-building fa-lg" />
      </Button>
      <Dialog
        open={isOpen}
        onClose={close}
        backdrop={<div className={dialogStyles.backdrop} />}
        className={dialogStyles.dialog}
        portal
        unmountOnHide
        hideOnEscape
        hideOnInteractOutside={false}
      >
        <div className={dialogStyles.header}>
          <DialogHeading className={dialogStyles.title}>
            Update {`${schoolAdminToUpdate.firstName} ${schoolAdminToUpdate.lastName}`} Schools
          </DialogHeading>
          <DialogDismiss className={dialogStyles.closeButton}>
            <span aria-hidden="true">&times;</span>
          </DialogDismiss>
        </div>
        <div className={dialogStyles.body}>
          <SchoolAdminSchoolsForm onSubmit={updateSchoolAdminSchoolsHandler} onCancel={close} />
        </div>
      </Dialog>
    </React.Fragment>
  )
}

export default SchoolsAdminSchoolsButtonModal
